<template>
	<!--(идет сразу после 19)-->
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div ng-controller="questDialogCtrl" clickable="nextLine()" @click="onModalClose(close)" class="questDialogBG unselectable clickable">
			<div class="dialogActor position0 show" ng-class="{show: dialogStarted}">
				<img src="//iwstatic.g.bsrv.su/img/x.gif" class="actor_envoy_illustration" data-cmp-info="10">
				<img src="//iwstatic.g.bsrv.su/img/x.gif" class="emotion envoy actor_envoy_emotion__illustration" data-cmp-info="10">
				<div class="tooltip textBubble position0 after actor_envoy typeMC" ng-class="{show: currentActor == 0}">
					<div class="tooltipContent ownText">
						<div ng-if="currentType != 'MC' || currentActor != 0">
							<div class="spokenText">Его светлость накопил достаточно влияния на эту деревню, чтобы пригласить тебя. Не хочешь ли ты присоединиться к королевству и стать его верноподданным?</div>
							<!-- ngIf: currentType=='input' -->
							<!-- ngIf: currentType=='input' -->
						</div>
						<!-- ngIf: currentType == 'MC' && currentActor == 0 -->
					</div>
				</div>
			</div>
			<div class="dialogActor position1 questGiverPortrait questGiver0 show" ng-class="{show: currentActor == 1}">
				<img src="//iwstatic.g.bsrv.su/img/x.gif" class="actor_myself_illustration" data-cmp-info="10">
				<div class="tooltip textBubble position1 above actor_myself show" ng-class="{show: currentActor == 1}">
					<div class="tooltipContent ownText">
						<!-- ngIf: currentType != 'MC'  || currentActor != 1 -->
						<div ng-if="currentType == 'MC' &amp;&amp; currentActor == 1">
							<ul>
								<li ng-repeat="currentLine in MClines" clickable="nextLine(3)" @click="onModalClose(close)" class="clickable">
									<a>Будет честью служить королю Хоттабыч.</a>
								</li>
								<li ng-repeat="currentLine in MClines" clickable="nextLine(4)" @click="onModalClose(close)" class="clickable">
									<a>К сожалению, придется отказаться.</a>
								</li>
								<li ng-repeat="currentLine in MClines" clickable="nextLine(5)" @click="onModalClose(close)" class="clickable">
									<a>Мне нужно об этом подумать.</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>